import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import ReactPlayer from "react-player";

import ButtonGhost from "../Button/ButtonGhost";
import ButtonSolid from "../Button/ButtonSolid";

const HomeIntro = ({ headingLevel, className }) => {
  const HeadingTag = headingLevel || "h2";

  return (
    <section className={`${className || "mb-20 pt-20 md:mb-32"}`}>
      <div className="container">
        <div className="mx-auto grid max-w-[1267px] items-center gap-y-8 md:grid-cols-2 md:gap-x-10 lg:gap-x-20">
          <div className="order-2 md:order-1">
            <HeadingTag>
              Business Intelligence Software Tailored for Real Estate
              Professionals
            </HeadingTag>
            <p>
              As a real estate professional, sleepless nights and uncertainty
              about the future of your business can be overwhelming. But it
              doesn't have to be that way.
            </p>
            <p>
              Introducing Realsynch—your personal business advisor and data
              powerhouse. Seamlessly integrating, aggregating, and analyzing
              your business data, Realsynch provides a crystal-clear view of
              where your business stands and where you should focus your
              efforts.
            </p>
            <p>
              With a user-friendly dashboard designed to enhance sales and
              productivity, you'll make confident, data-driven decisions that
              drive success for both you and your agents—all without needing
              advanced computer skills.
            </p>

            <ButtonSolid
              altStyle={2}
              // modal="modal-contact"
              text="Start Free Trial"
              href="/free-trial"
            />
          </div>
          <div className="order-1 drop-shadow-lg md:order-2 ">
            <StaticImage
              src="../../images/1.0 Homepage/intro-image.png"
              loading="lazy"
              objectFit="contain"
              width={709}
              height={540}
            />
          </div>
        </div>
      </div>
      <div
        className="mx-auto mt-20 flex w-full items-center justify-center px-4"
        id="explainer-video"
      >
        <ReactPlayer
          url="https://vimeo.com/1084329788?share=copy"
          controls={true}
        />
      </div>
    </section>
  );
};

export default HomeIntro;
